import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = async (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions)

export const fetchAssayBaseline = ({
  pipelineID, 
  workspaceId,
  locations,
  start = null, 
  end = null, 
  limit = null, 
  next = null
}) => {
  const body = {
    pipeline_name: pipelineID,
    workspace_id: workspaceId,
    start,
    end,
    limit,
    next,
  };

  // Assumes if no locations are selected - the endpoint returns data for all locations
  if (locations?.length) {
    body.locations = locations;
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(body)
  };

  return postToApi('v1/api/assays/get_baseline', fetchOptions)
}

// Wrapper for SWR Fetch Function
export const swrAssayBaselineFetcher = (queryParams) => {
  const [pipelineID, workspaceId, limit, locations] = queryParams;

  return fetchAssayBaseline({
    pipelineID, workspaceId, limit, locations
  })
}

export default fetchAssayBaseline;
